import React from 'react';
import { isInvalidFieldsError, isInvalidTableError } from '../helper';
import DataManagementDictionaryErrorTable from './DataManagementDictionaryErrorTable';
import DataManagementDictionaryFieldErrorsTable from './DataManagementDictionaryFieldErrorsTable';

const ValidateDataResultsInvalid = ({
  errors,
}) => (
  <>
    {isInvalidTableError(errors) && (
      <DataManagementDictionaryErrorTable error={errors[0].message} />
    )}
    {isInvalidFieldsError(errors) && (
    <DataManagementDictionaryFieldErrorsTable errors={errors} />
    )}
  </>
);

export default ValidateDataResultsInvalid;
